var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "request-status-select" }, [
    _c("div", { staticClass: "select is-full-cell" }, [
      _c(
        "select",
        {
          attrs: { disabled: _vm.isLoading },
          domProps: { value: _vm.currentStatus },
          on: { input: _vm.handleStatusChange },
        },
        _vm._l(_vm.statusesList, function (status) {
          return _c(
            "option",
            { key: status.key, domProps: { value: status.key } },
            [_vm._v(_vm._s(status.value))]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _vm.isLoading
      ? _c("i", { staticClass: "material-icons icon-spin" }, [_vm._v("sync")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }